import attend_store from "../../store/attend_store";
import guideline_store from "../../store/guideline_store";
import student_store from "../../store/student_store";
import coursestatus_store from "../../store/coursestatus_store";
import course_store from "../../store/course_store";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import courseset_store from "../../store/courseset_store";
import { Submit_Attend } from "../Submit_Attend";
import { Loading } from "../../component/Loading";
import { Course } from "./Course";
import { AdditionalCourse } from "./CourseAddictional";

function AttendPage() {
  //#region stores

  // Student Store
  const student = student_store((state) => state.student);
  const attendsBaseOnStudent = attend_store(
    (state) => state.attendsBaseOnStudent
  );
  const editAttend = attend_store((state) => state.editAttend);
  const getstudent = student_store((state) => state.getstudent);

  const getGuidelines = guideline_store((state) => state.getGuidelines);

  // coursestatus Store
  const coursestatus_store_obj = coursestatus_store(
    (state) => state.coursestatus
  );

  // course Store get all courses as categoryCourse
  const getCategoryCourses = course_store((state) => state.getCourses);

  // get all attend
  const getAttendsBaseOnStudent = attend_store(
    (state) => state.getAttendsBaseOnStudent
  );

  // get all coursestatus
  const getcoursestatus = coursestatus_store((state) => state.getcoursestatus);

  // get courseSet Base on major from coursesetStore
  const getcoursesetBaseOnMajor = courseset_store(
    (state) => state.getcoursesetBaseOnMajor
  );
  // courseSet Base on major data
  const coursesetBaseOnMajor = courseset_store(
    (state) => state.coursesetBaseOnMajor
  );

  //#endregion

  //#region function and variables

  let [credits, setCredits] = useState(0);
  let [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const date = new Date();
  let isLoading = false;
  let rank = 0;
  let isBuildNewRank = true;
  let isBuildCreditCount = true;
  let scopeOfFiveCourse = 0;
  let isMaxCount = 0;
  let isAlternativeCount = 0;

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        getstudent(),
        getAttendsBaseOnStudent(),
        getcoursestatus(),
        getcoursesetBaseOnMajor(),
        getGuidelines(),
        getCategoryCourses(),
      ]);
    };
    fetchData();
  }, []);

  const handleStatusChange = (coursesetIndex, statusIndex) => {
    coursesetBaseOnMajor.data[coursesetIndex].coursestatus =
      coursestatus_store_obj.data[statusIndex];
  };
  const statusRequest = (
    attendsBaseOnStudent?.data?.[0]?.statusRequest ?? ""
  ).toLowerCase();

  const handleAddCourse = (name, status, index) => {
    const objectFound = coursesetBaseOnMajor.data[0];
    coursesetBaseOnMajor.data[index] = objectFound;
  };

  const generateTableHTML = (json) => {
    let tableHTML = `<table cellspacing=0 className="table"> <thead> <tr style="background: #002855; color: #dedede;" className="bg-primary"> <th style="padding: 10px;" className="text-white">Course Code and Description</th> <th style="padding: 10px;" className="text-white">Credits</th> <th style="padding: 10px;" className="text-white">Prerequisite(s)</th> <th style="padding: 10px;" className="text-white">Status</th> </tr> </thead> <tbody>`;

    let rank = "";
    let scopeOfFiveCourse = 0;

    json?.forEach((element, index) => {
      if (element.rank !== rank && element.rank !== "" && element.rank) {
        rank = element.rank;
        scopeOfFiveCourse = 0;
        tableHTML += `<tr style="background: #c99700; color:black;" > <td className="bg-warning fw-bold" style="padding: 0 10px; " >Semester ${element.rank}</td> <td style="" className="bg-warning"></td> <td className="bg-warning" style=""></td> <td className="bg-warning" style=""></td> </tr>`;
      } else {
        scopeOfFiveCourse++;
      }

      tableHTML += `<tr style="color:black;  " > <td style="padding: 5px 10px; border-bottom: 1.5px solid #b0aaaa;">${element?.name}</td> <td style="text-align: center; border-bottom: 1.5px solid #b0aaaa;">${element?.credit}</td> <td style="padding: 5px 10px; border-bottom: 1.5px solid #b0aaaa; text-align:center;">${element?.preRequisite}</td> <td style="text-align: center; padding: 5px 10px; border-bottom: 1.5px solid #b0aaaa;" >${element.coursestatus}</td> </tr>`;
    });

    tableHTML += ` </tbody> </table>`;

    return tableHTML;
  };

  const edit = async () => {
    isMaxCount = 0;
    let courseIDArray = [];
    let courseStatusIDArray = [];
    let htmlTableJson = [];
    for (let index = 0; index < coursesetBaseOnMajor.data.length; index++) {
      const object = coursesetBaseOnMajor.data[index];
      const length = Object.keys(object).length;
      if (length == 0) continue;

      let courseset;
      //   if for finding the courseset id inside the course.courseset object, (Category courses).
      // else for finding the courseset id inside the courseset, (Normal courses)
      if (Object.keys(object?.courseset ?? {}).length != 0) {
        courseset = object.courseset[0].id;
      } else if (Object.keys(object).length != 0) {
        courseset = object.id;
      }

      if (courseset) {
        courseIDArray.push(courseset);
        // set statusid as 1 for the courses student didn't filled.
        courseStatusIDArray.push(object?.coursestatus?.id ?? 1);

        let name, credit, preRequisite, coursestatus, rank;

        if (!object.courseset) {
          name = object.course.code + " " + object.course.name;
          credit = object.course.credit;
          preRequisite = object.course.preRequisite;
          coursestatus = object.coursestatus?.name ?? "None";
          rank = object.rank;
        } else {
          name = object.code + " " + object.name;
          credit = object.credit;
          preRequisite = object.preRequisite;
          coursestatus = object.coursestatus?.name ?? "None";
          rank = object.courseset.rank;
        }

        const tableRecord = {
          name,
          credit,
          preRequisite,
          coursestatus,
          rank,
        };
        htmlTableJson.push(tableRecord);
      }
    }

    const htmlTable = generateTableHTML(htmlTableJson);

    courseStatusIDArray.find((e, i) => {
      if ([3, 5, 9, 12, 15, 18].includes(e)) ++isMaxCount;
      else if ([4, 19, 20, 21, 22].includes(e)) ++isAlternativeCount;
    });

    let isError = false;

    if (isMaxCount > student?.majors?.[0]?.maxMainCourse ?? 0) {
      isError = true;
      toast.error(
        "you can only select " +
        (student?.majors?.[0]?.maxMainCourse ?? 0) +
        " main and retake courses status or less"
      );
    }


    if (isMaxCount < 1) {
      isError = true;
      toast.error("you have to select 1 main course atleast");
    }
    if (isAlternativeCount > student?.majors?.[0]?.maxAlternativeCourse ?? 0) {
      isError = true;
      toast.error(
        "you can only select " +
        (student?.majors?.[0]?.maxAlternativeCourse ?? 0) +
        " alternative courses"
      );
    }

    isMaxCount = 0;
    isAlternativeCount = 0;

    if (isError) return;

    try {
      setIsSubmitLoading(true)

      courseStatusIDArray.length = courseIDArray.length;

      const result = await editAttend(
        {
          student: student?.id ?? -1,
          date: date,
          howAttend: '',
          statusRequest: "pending",
          table: htmlTable,
          tableJson: JSON.stringify(htmlTableJson),
          supervisor: student?.supervisors?.[0]?.id ?? -1,
        },
        courseIDArray ?? [],
        courseStatusIDArray ?? []
      );

      if (result?.status == 200 || result?.status == 201) {
        let msg = "Form submission succeed";
        toast.success(msg);
        setIsSubmitLoading(false)
      }
    } catch (error) {
      setIsSubmitLoading(false)

      const errmsg = error.response?.data?.message;
      if (!errmsg) return;

      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
    finally {
      setIsSubmitLoading(false)

    }
  };

  //#endregion

  if ((coursesetBaseOnMajor?.data?.length ?? 0) == 0) {
    return <Loading />;
  }

  if ((coursestatus_store_obj?.data?.length ?? 0) == 0) {
    return <Loading />;
  }

  coursesetBaseOnMajor?.data?.map((courseset, index) => {
    let cond = false;
    let attendStatus;
    attendsBaseOnStudent?.data?.map((attend) => {
      if (courseset.id == attend.courseset.id) {
        cond = true;
        attendStatus = attend.coursestatus;
      }
    });
    if (cond) {
      coursesetBaseOnMajor.data[index].coursestatus = attendStatus;
      isLoading = true;
    } else {
      isLoading = true;
    }
  });

  if (!isLoading) {
    return <Loading />;
  }

  if (!attendsBaseOnStudent?.data)
    return <Loading key={`Loading3rd-attend2`} />;

  const note = attendsBaseOnStudent?.data?.[0]?.note ?? "";

  const bgcolor =
    statusRequest === "pending"
      ? "warning"
      : statusRequest === "approved"
        ? "success"
        : "danger";

  return (
    <div>
      <h6>Advisor name: {student?.supervisors?.[0]?.name ?? ""}</h6>
      <h6>Advisor email: {student?.supervisors?.[0]?.email ?? ""}</h6>
      {student?.cohorts?.[0]?.instruction && (
        <h6> Cohort instruction: {student?.cohorts?.[0]?.instruction ?? ""}</h6>
      )}
      <br />
      {
        <table border={1} className="table">
          <thead>
            <tr border={1} className="bg-primary">
              <th className="text-white">Couse Code and Description</th>
              <th className="text-white">Credits</th>
              <th className="text-white">Prerequisite(s)</th>
              <th className="text-white">Status</th>
            </tr>
          </thead>
          <tbody>
            {coursesetBaseOnMajor?.data?.map((course, coursesetIndex) => {
              if (course.rank != rank && course.rank != "" && course.rank) {
                rank = course.rank;
                isBuildNewRank = true;
                credits = 0;
                scopeOfFiveCourse = 0;
              } else {
                isBuildNewRank = false;
                scopeOfFiveCourse++;
              }
              if (!coursesetBaseOnMajor?.data?.[coursesetIndex + 1]) {
                isBuildCreditCount = true;
              } else {
                if (
                  coursesetBaseOnMajor?.data?.[coursesetIndex + 1].rank !=
                  coursesetBaseOnMajor?.data?.[coursesetIndex].rank &&
                  (coursesetBaseOnMajor?.data?.[coursesetIndex + 1]?.rank ??
                    "") != ""
                ) {
                  isBuildCreditCount = true;
                } else {
                  isBuildCreditCount = false;
                }
              }
              credits += course?.course?.credit ?? 0;

              if (!course.rank)
                return (
                  <AdditionalCourse
                    key={`course-additionallll-${coursesetIndex}`}
                    course={course}
                    credits={credits}
                    statusRequest={statusRequest} // [approve,reject,pending]
                    coursestatus={coursestatus_store_obj}
                    isBuildCreditCount={isBuildCreditCount}
                    handleStatusChange={(status) =>
                      handleStatusChange(coursesetIndex, status)
                    }
                    coursesetBaseOnMajor={coursesetBaseOnMajor}
                    index={coursesetIndex}
                    onAdd={handleAddCourse}
                  />
                );

              const attendedCourse = attendsBaseOnStudent?.data?.find(
                (attend) => attend.courseset.id === course.id
              );

              const boolcheck = Object.keys(attendedCourse ?? {}).length > 0;

              // if you expected null object, check the parent then their child, the below code is not needed if you try the above code
              // if (!boolcheck) {
              //     return null
              // }

              return (
                <Course
                  key={`courserrr-${coursesetIndex}`}
                  course={course} // The current single courseset object
                  credits={credits} // The total credits of the courses
                  coursestatus={coursestatus_store_obj} // status list
                  isBuildCreditCount={isBuildCreditCount}
                  statusRequest={statusRequest} // [approve,reject,pending]
                  attendsBaseOnStudent={attendsBaseOnStudent} // attend list
                  attendedCourse={attendedCourse} // The current single attended course
                  isBuildNewRank={isBuildNewRank}
                  coursesetBaseOnMajor={coursesetBaseOnMajor}
                  coursesetIndex={coursesetIndex}
                  handleStatusChange={(statusIndex) =>
                    handleStatusChange(coursesetIndex, statusIndex)
                  } // Passing a anonymous
                //  function that need single argument to call a function from the attend2.js which is got 2 argument
                //  already index got from the courseset.map, and gets the status from the anonymous function which is
                // sent to the <course /> function component
                />
              );
            })}
          </tbody>
        </table>
      }

      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight"></div>

        <div className="p-2 bd-highlight">
          <div className="d-flex flex-row-reverse bd-highlight" >
            <Submit_Attend isSubmitLoading={isSubmitLoading} setIsSubmitLoading={setIsSubmitLoading} disabled={statusRequest === "approved"} edit={edit} />
          </div>
        </div>
      </div>

      <div className="d-flex flex-row bd-highlight mb-3">
        <h6>Status: </h6>
        &nbsp;
        <h6 className={`text-${bgcolor}`}>{statusRequest}</h6>
      </div>
      {statusRequest === "rejected" && (
        <div className="d-flex flex-row bd-highlight mb-3">
          <h6 className="pt-1">Note: </h6> <h6 className="text-danger"></h6>
          &nbsp; &nbsp;
          <div
            className={`text-${bgcolor}`}
            dangerouslySetInnerHTML={{
              __html: note,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default AttendPage;
